import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import { ToastContainer, toast } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";

import { getNotificationReadStatus } from "../../Network/services/notificationInfoService";

import "../../assets/css/alert.css";

const NotificationBtn = () => {

    const [notificationReadStatusCount, setNotificationReadStatusCount] = useState(0);
    const [notificationsCount, setNotificationsCount] = useState(0);

    useEffect(() => {        
    
        const notification_read_status = new FormData();      
        getNotificationReadStatus(notification_read_status)
        .then(async (res) => {
        if (res.status == 200) {


            setNotificationReadStatusCount(res.read_status)
            setNotificationsCount(res.notification_count)

         
            
        } else {
            toast.success(res.message, {
            position: "top-right",
            type: "error",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
            });
        }
        })
        .catch((err) => {
        toast.success("Something went wrong! please try again later!!", {
            position: "top-right",
            type: "error",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
        });
        })
        .finally(() => {
        });
    
      }, []);

    return(
        <span className="notify-icon">
            <Link className="btn btn-default" to="/notifications">
                <img 
                  src="/assets/images/NotificationIcon.svg" 
                  className="bell-icon"
                /> 
                <sup>{notificationsCount > 99 ? '99+' : notificationsCount}</sup>
            </Link>
        </span>
    )

}

export default NotificationBtn;

